import React from "react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { responsiveFont, responsivePaddingVertical, responsivePaddingHorizontal, responsiveImageSize } from '../../common/responsive.utils';
    
import Icon01_Web from '../../../assets/icon/partner/schedule.svg';
import Icon02_Web from '../../../assets/icon/partner/users_character.svg';
import Icon03_Web from '../../../assets/icon/partner/message.svg';
import Icon04_Web from '../../../assets/icon/partner/ticket.svg';
import Icon05_Web from '../../../assets/icon/partner/tel.svg';
import Icon06_Web from '../../../assets/icon/partner/chat.svg';
import Icon01_Mobile from '../../../assets/icon/partner/schedule.svg';
import Icon02_Mobile from '../../../assets/icon/partner/users_character.svg';
import Icon03_Mobile from '../../../assets/icon/partner/message.svg';
import Icon04_Mobile from '../../../assets/icon/partner/ticket.svg';
import Icon05_Mobile from '../../../assets/icon/partner/tel.svg';
import Icon06_Mobile from '../../../assets/icon/partner/chat.svg';

const Component02 = ({...props}) : React.ReactElement => { 
    // 데스크탑-웹: 768px ~ 1920px
    const isWeb = useMediaQuery('(min-width:768px)', {noSsr : true});
    const styles = getStyles(); 

    return (
        <>
            {isWeb ? (
                <> 
                    <div style={styles.screen_Web}>
                        <div style={{ marginBottom:"60px"}}>  
                            <span style={styles.titleTxt_Web}>
                                우주펫 파트너에서 <br/> 예약 관리를 무료 이용해 보세요
                            </span>
                        </div>
                        <div style={{ height: "1vw" }} />

                        <div style={styles.divRow_Web} >
                                
                            <div style={styles.divColumn_Web}>    
                                <img src={Icon01_Web} style={styles.icon_Web} alt="예약 관리" />

                                <span style={styles.subTitleTxt_Web}>
                                    예약 관리
                                </span>

                                <span style={styles.contentTxt_Web}>
                                    예약 현황을 한눈에 보고, <br />
                                    다가오는 스케줄도 쉽게 확인할 수 있어요.
                                </span>
                            </div>

                            <div style={styles.divColumn_Web}>    
                                <img src={Icon02_Web} style={styles.icon_Web} alt="고객 관리" />

                                    <span style={styles.subTitleTxt_Web}>
                                        고객 관리
                                    </span>
                                
                                    <span style={styles.contentTxt_Web}>
                                        보호자와 반려동물 정보 등록 및<br />
                                        확인이 간편해요.
                                    </span>    
                            </div>

                            <div style={styles.divColumn_Web}>    
                                <img src={Icon03_Web} style={styles.icon_Web} alt="자동 알림톡" />

                                <span style={styles.subTitleTxt_Web}>
                                    자동 알림톡
                                </span>
                            
                                <span style={styles.contentTxt_Web}>
                                    예약 확정부터 리마인드 까지,<br />
                                    모든 안내가 자동 알림톡으로 발송돼요.
                                </span>     
                            </div>

                        </div>
                        <div style={styles.divRow_Web}>
                                
                            <div style={styles.divColumn_Web}>    
                                <img src={Icon04_Web} style={styles.icon_Web} alt="이용권 관리" />

                                <span style={styles.subTitleTxt_Web}>
                                    이용권 관리
                                </span>
                            
                                <span style={styles.contentTxt_Web}>
                                    매장에서 사용하는 이용권을<br />
                                    그대로 지급하고 차감할 수 있어요.
                                </span>
                            </div>


                            <div style={styles.divColumn_Web}>    
                                <img src={Icon05_Web} style={styles.icon_Web} alt="안심번호 제공" />

                                    <span style={styles.subTitleTxt_Web}>
                                        안심번호 제공
                                    </span>
                            
                                    <span style={styles.contentTxt_Web}>
                                        개인 연락처 노출없이<br />
                                        무료로 050 안심번호를 제공해 드려요.
                                    </span>    
                            </div>

                            <div style={styles.divColumn_Web}>      
                                <img src={Icon06_Web} style={styles.icon_Web} alt="채팅" />

                                <span style={styles.subTitleTxt_Web}>
                                    채팅
                                </span>

                                <span style={styles.contentTxt_Web}>
                                    고객과의 1:1 채팅으로<br />
                                    사진, 영상도 자유롭게 보낼 수 있어요.
                                </span>     
                            </div>
                            </div>
                    </div>
                </>
                ) : (
                <>
                    <div style={styles.componentIntro_Mobile} >
                        <p style={styles.componentIntroTitleTxt_Mobile}>
                            우주펫 파트너에서 <br /> 예약 관리를 무료 이용해 보세요
                        </p>

                        <div style={{ height: "6.6vh" }} />
                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon01_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.4483vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                예약 관리
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                예약 현황을 한눈에 보고,
                                <br />
                                다가오는 스케줄도 쉽게 확인할 수 있어요.
                            </p>

                        </div>

                        <div style={{ height: "6.6vh" }} />
                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon02_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.5vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                고객 관리
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                보호자와 반려동물 정보 등록 및
                                <br />
                                확인이 간편해요.
                            </p>
                        </div>

                        <div style={{ height: "6.6vh" }} />

                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon03_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.5vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                자동 알림톡
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                예약 확정부터 리마인드 까지,
                                <br />
                                모든 안내가 자동 알림톡으로 발송돼요.
                            </p>
                        </div>

                        <div style={{ height: "6.6vh" }} />

                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon04_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.5vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                이용권 관리
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                매장에서 사용하는 이용권을
                                <br />
                                그대로 지급하고 차감할 수 있어요.
                            </p>
                        </div>

                        <div style={{ height: "6.6vh" }} />

                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon05_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.5vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                안심번호 제공
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                개인 연락처 노출없이
                                <br />
                                무료로 050 안심번호를 제공해 드려요.
                            </p>
                        </div>

                        <div style={{ height: "6.6vh" }} />

                        <div style={styles.subIntroCon_Mobile}>
                            <img src={Icon06_Mobile} alt="" style={{ width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100) }} />
                            <div style={{ height: "1.5vh" }} />
                            <p style={styles.introTxt_Mobile} >
                                채팅
                            </p>
                            <div style={{ height: "0.5172vh" }} />
                            <p style={styles.introContentTxt_Mobile}>
                                고객과의 1:1 채팅으로
                                <br />
                                사진, 영상도 자유롭게 보낼 수 있어요.
                            </p>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

const getStyles = (): Record<string, React.CSSProperties> => ({
    screen_Web: {background: "#FFFFF", paddingBottom: responsivePaddingVertical(50, 110), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88)},
    titleTxt_Web: { fontFamily: "Pretendard", fontWeight: 800, fontSize: responsiveFont(22, 40), lineHeight:"120%", letterSpacing:"-1%"},
    subTitleTxt_Web: { marginBottom: "12px", fontFamily: "Pretendard", fontWeight: 700, fontSize: responsiveFont(18, 34), lineHeight: "120%", letterSpacing: "-1%", textAlign: "center", color:"#9F6BFF"},
    contentTxt_Web: { fontFamily: "Pretendard", fontWeight: 400, fontSize: responsiveFont(14, 26), lineHeight: "140%", letterSpacing: "-3%", textAlign: "center", color:"#62686D"},
    icon_Web: { width: responsiveImageSize(58, 100), height: responsiveImageSize(58, 100), marginBottom:"30px"},
    divRow_Web: { display: "flex", flexDirection: "row", justifyContent: "space-evenly", alignItems: "center"},
    divColumn_Web: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingBottom: "5vw", width:"422px"},

    componentIntro_Mobile: { width: "100%", minWidth: "320px", backgroundColor: "#FFF", paddingBottom: responsivePaddingVertical(50, 110), paddingTop: responsivePaddingVertical(50, 90), paddingLeft: responsivePaddingHorizontal(24, 88), paddingRight: responsivePaddingHorizontal(24, 88), margin: 0, boxSizing: "border-box", },
    componentIntroTitleTxt_Mobile: { fontFamily: "'Pretendard'", fontWeight: 700, fontSize: responsiveFont(22, 40) , lineHeight: "140%", letterSpacing: "-0.03em", textAlign: "left", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "black", margin: 0, padding: 0, },
    subIntroCon_Mobile: { width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", },
    introTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(18, 34), lineHeight: "120%", fontWeight: 700, letterSpacing: "-0.03em", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#9F6BFF", textShadow: "none", margin: 0, padding: 0, },
    introContentTxt_Mobile: { fontFamily: "'Pretendard'", fontSize: responsiveFont(14, 26), lineHeight: "140%", fontWeight: 400, letterSpacing: "-0.03em", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", color: "#62686D", textShadow: "none", margin: 0, padding: 0, },
});

export default Component02;